import { dbdelete } from '../../api/dbdelete.js';
import { dbinsert } from '../../api/dbinsert.js';
import { dbupdate } from '../../api/dbupdate.js';
import * as types from '../constants/ActionTypes.js';

export const editChecked1 = checked => ({ type: types.EDIT_CHECKED1, checked })
export const editChecked2 = checked => ({ type: types.EDIT_CHECKED2, checked })
export const serviceAddData = (data, index) => ({ type: types.ADD_DATA, data, index })
export const serviceEditList1 = (index, list2_id) => ({ type: types.EDIT_LIST1, index, list2_id })
export const serviceAddList1 = (name) => ({ type: types.ADD_LIST1, name })
export const serviceDeleteList1 = (id) => ({ type: types.DELETE_LIST1, id })
export const serviceRemoveId = (id2) => ({ type: types.REMOVE_ID, id2 })
export const serviceAddList2 = (name) => ({ type: types.ADD_LIST2, name })
export const serviceDeleteList2 = (id) => ({ type: types.DELETE_LIST2, id })
export const serviceCheckList1 = (list1_index) => ({ type: types.CHECK_LIST1, list1_index })
export const serviceCheckList2 = (list2_index) => ({ type: types.CHECK_LIST2, list2_index })
export const serviceSaveData = (data, list2_index) => ({ type: types.SAVE_DATA, data, list2_index })
export const serviceDeleteData = (id, list_index) => ({ type: types.DELETE_DATA, id, list_index })


// Service related actions
export const serviceInsert = (service) => {
  return (dispatch) => {
    const max = service.reduce((prev, curr) => (Number(prev.serviceorder) > Number(curr.serviceorder)) ? prev : curr, { serviceorder: 0 })
    let ordervalue = Number(max.serviceorder) + 1
    let defaults = { description: "Uusi Palvelu", serviceorder: ordervalue }
    dbinsert('service', defaults).then(response => {
      dispatch({ type: types.INSERT_SERVICE, response})
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const serviceDelete = (id) => {
  return (dispatch, getState) => {
    dbdelete('service', id).then(response => {
      const servicepackageservices = getState().servicePackageServiceReducer.filter(obj => { return obj.serviceid === id })
      for (const sps of servicepackageservices) {
        dispatch({ type: types.DELETE_SERVICEPACKAGESERVICE, spsid: sps.servicepackageserviceid })
      }
      dispatch({ type: types.DELETE_SERVICE, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const serviceUpdate = (json, id) => {
  return (dispatch) => {
    const updatedState = { ...json, serviceid: id }
    dbupdate('service', id, updatedState).then(response => {
      dispatch({ type: types.UPDATE_SERVICE, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Service package related actions
export const servicePackageInsert = (servicepackage) => {
  return (dispatch) => {
    const max = servicepackage.reduce((prev, curr) => (Number(prev.sporder) > Number(curr.sporder)) ? prev : curr, { sporder: 0 })
    let ordervalue = Number(max.sporder) + 10
    let defaults = { description: "Uusi Paketti", sporder: ordervalue }
    dbinsert('servicepackage', defaults).then(response => {
      dispatch({ type: types.INSERT_SERVICEPACKAGE, response })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const servicePackageDelete = (id) => {
  return (dispatch, getState) => {
    dbdelete('servicepackage', id).then(response => {
      const servicepackageservices = getState().servicePackageServiceReducer.filter(obj => { return obj.servicepackageid === id })
      for (const sps of servicepackageservices) {
        dispatch({ type: types.DELETE_SERVICEPACKAGESERVICE, spsid: sps.servicepackageserviceid })
      }
      dispatch({ type: types.DELETE_SERVICEPACKAGE, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
} 
export const servicePackageUpdate = (json, id) => {
  return (dispatch) => {
    const updatedState = { ...json, servicepackageid: id }
    dbupdate('servicepackage', id, updatedState).then(response => {
      dispatch({ type: types.UPDATE_SERVICEPACKAGE, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Service question related actions
export const serviceQuestionInsert = (servicequestion, sid, sqid, sqorder) => {
  console.log("Adding servicequestion: " + servicequestion + " sid: " + sid + " sqid: " + sqid + " sqorder: " + sqorder)
  return (dispatch) => {
    let defaults = {}
    if(!servicequestion){
      if (sqid) {
        defaults = { description: "Uusi Kysymys", serviceid: sid, parent: sqid, required: false, sqorder: sqorder | 0}
        console.log("sqinsert 1: " + sqid)
      } else {
        defaults = { description: "Uusi Kysymys", serviceid: sid, required: false, sqorder: sqorder | 0}
        console.log("sqinsert 2: " + sqid)
      }
    } else {
      defaults = {...servicequestion, sqorder: sqorder | 0}
    }
    console.log('sqInsert: ' + JSON.stringify(defaults))
    return dbinsert('servicequestion', defaults).then(response => {
      dispatch({ type: types.INSERT_SERVICEQUESTION, response })
      return response
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
      throw error
    })
  }
}

export const serviceQuestionDelete = (id) => {
  return (dispatch, getState) => {
    dbdelete('servicequestion', id).then(response => {
      const multichoices = getState().serviceQuestionMultiChoiceReducer.filter(obj => { return obj.servicequestionid === id })
      for (const mc of multichoices) {
        dispatch({ type: types.DELETE_SERVICEQUESTIONMULTICHOICE, id: mc.servicequestionmultichoiceid })
      }
      const findAllChildrens = (state, parentId) => {
        const childrens = state.filter((question) => question.parent === parentId)
        for (const child of childrens) {
          const multichoices = getState().serviceQuestionMultiChoiceReducer.filter(obj => { return obj.servicequestionid === child.servicequestionid })
          for (const mc of multichoices) {
            dispatch({ type: types.DELETE_SERVICEQUESTIONMULTICHOICE, id: mc.servicequestionmultichoiceid })
          }
          dispatch({ type: types.DELETE_SERVICEQUESTION, id: child.servicequestionid })
          findAllChildrens(state, child.servicequestionid)
        }
      }
      const state = getState().serviceQuestionReducer
      findAllChildrens(state, id)
      dispatch({ type: types.DELETE_SERVICEQUESTION, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

export const serviceQuestionUpdate = (json, id) => {
  return (dispatch, getState) => {
    const state = getState().serviceQuestionReducer
    const serviceQuestion = state.filter(obj => { return obj.servicequestionid === id })
    const updatedState = { ...serviceQuestion[0], ...json}
    dbupdate('servicequestion', id, updatedState).then(response => {
      const multichoices = getState().serviceQuestionMultiChoiceReducer.filter(obj => { return obj.servicequestionid === id })
      if(json.questiontype && (json.questiontype !== 'multi' || json.questiontype !== 'one' || json.questiontype !== 'list')) {
        for (const mc of multichoices) {
          dispatch({ type: types.DELETE_SERVICEQUESTIONMULTICHOICE, id: mc.servicequestionmultichoiceid })
        }
      }
      dispatch({ type: types.UPDATE_SERVICEQUESTION, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Phase related actions
export const phaseInsert = (phase, spid) => {
  return (dispatch) => {
    const max = phase.filter(obj => { return obj.servicepackageid === spid }).reduce((prev, curr) => (Number(prev.phaseorder) > Number(curr.phaseorder)) ? prev : curr, { phaseorder: 0 })
    let ordervalue = Number(max.phaseorder) + 1
    let defaults = { description: "Uusi Vaihe", title: "Vaiheen nimi", servicepackageid: spid, phaseorder: ordervalue }
    dbinsert('phase', defaults).then(response => {
      dispatch({ type: types.INSERT_PHASE, response })
    })
      .catch(error => {
        // Deal with the error
        dispatch({ type: types.CREATE_ERROR, error })
      })
  }
}
export const phaseDelete = (id) => {
  return (dispatch, getState) => {
    dbdelete('phase', id).then(response => {
      const servicepackageservices = getState().servicePackageServiceReducer.filter(obj => { return obj.phaseid === id })
      for (const sps of servicepackageservices) {
        dispatch({ type: types.DELETE_SERVICEPACKAGESERVICE, spsid: sps.servicepackageserviceid })
      }
      dispatch({ type: types.DELETE_PHASE, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const phaseUpdate = (json, id) => {
  return (dispatch) => {
    const updatedState = { ...json, phaseid: id }
    dbupdate('phase', id, updatedState).then(response => {
      dispatch({ type: types.UPDATE_PHASE, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Service question multi choice related actions
export const serviceQuestionMultiChoiceInsert = (servicequestionmultichoice, sqid) => {
  return (dispatch) => {
  const max = servicequestionmultichoice.filter(obj => { return obj.servicequestionid === sqid }).reduce((prev, curr) => (Number(prev.sqmcorder) > Number(curr.sqmcorder)) ? prev : curr, { sqmcorder: 0 })
  let ordervalue = Number(max.sqmcorder) + 1
  let defaults = { description: "Uusi Vaihtoehto", servicequestionid: sqid, sqmcorder: ordervalue }
  dbinsert('servicequestionmultichoice', defaults).then(response => {
    dispatch({ type: types.INSERT_SERVICEQUESTIONMULTICHOICE, response })
  }).catch(error => {
    // Deal with the error
    dispatch({ type: types.CREATE_ERROR, error })
  })
  }
}
export const serviceQuestionMultiChoiceDelete = (id) => {
  return (dispatch) => {
    dbdelete('servicequestionmultichoice', id).then(response => {
      dispatch({ type: types.DELETE_SERVICEQUESTIONMULTICHOICE, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const serviceQuestionMultiChoiceUpdate = (json, id) => {
  return (dispatch, getState) => {
    const state = getState().serviceQuestionMultiChoiceReducer
    const serviceQuestionMultiChoice = state.filter(obj => { return obj.servicequestionmultichoiceid === id })
    const updatedState = { ...serviceQuestionMultiChoice[0], ...json}
    dbupdate('servicequestionmultichoice', id, updatedState).then(response => {
      dispatch({ type: types.UPDATE_SERVICEQUESTIONMULTICHOICE, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Service package service related actions
export const servicePackageServiceInsert = (data) => {
  return (dispatch) => {
    dbinsert('servicepackageservice', data).then(response => {
      dispatch({ type: types.INSERT_SERVICEPACKAGESERVICE, response })
    })
      .catch(error => {
        // Deal with the error
        dispatch({ type: types.CREATE_ERROR, error })
      })
  }
}
export const servicePackageServiceDelete = (spsid) => {
  return (dispatch) => {
    dbdelete('servicepackageservice', spsid).then(response => {
      dispatch({ type: types.DELETE_SERVICEPACKAGESERVICE, spsid })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}
export const servicePackageServiceUpdate = (json, id) => {
  return (dispatch) => {
    const updatedState = { ...json, servicepackageserviceid: id }
    dbupdate('servicepackageservice', id, updatedState).then(response => {
      dispatch({ type: types.UPDATE_SERVICEPACKAGESERVICE, json, id })
    }).catch(error => {
      // Deal with the error
      dispatch({ type: types.CREATE_ERROR, error })
    })
  }
}

// Error handling actions
export const errorCreate = () => ({ type: types.CREATE_ERROR })